/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var NotificationLevel;

(function (NotificationLevel) {
  NotificationLevel["INFO"] = "info";
  NotificationLevel["WARNING"] = "warning";
  NotificationLevel["ERROR"] = "error";
})(NotificationLevel || (NotificationLevel = {}));